/**
 * Strandningsmeddelande enligt 18 § hyresförhandlingslagen (1978:304).
 *
 * A letter, not an agreement: no numbered points, one signing party, and
 * delivery by registered post rather than an e-signing provider. The
 * recipient organisation is a party with `signs: false`, so it never blocks
 * the signing roster.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { signingPartiesFor } from '../common/index.js';
const TITLE = 'Strandningsmeddelande enligt 18 § hyresförhandlingslagen (1978:304)';
const FORM_NUMBER = 'Formulär R-21';
const PARTY_SLOTS = [
    { id: 'lessor', label: 'Hyresvärd', role: 'lessor', ordinal: 0, required: true, signs: true },
    {
        id: 'tenant_org',
        label: 'Hyresgästorganisation',
        role: 'other',
        ordinal: 0,
        required: true,
        signs: false,
        kind: 'organisation',
        help: 'Den hyresgästorganisation som är part i förhandlingsordningen.',
    },
];
export const strandningsmeddelandeV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'strandningsmeddelande',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Bostadshyressättningsavtal',
        shortTitle: 'Strandningsmeddelande',
        formNumber: FORM_NUMBER,
        statute: '18 § hyresförhandlingslagen (1978:304)',
        signingMode: 'manual_delivery',
        preamble: 'Hyresvärdens meddelande om att förhandling enligt hyresförhandlingslagen har strandat (18 §).',
        partySlots: PARTY_SLOTS,
        propertySlots: [{ id: 'property', label: 'Fastighet', required: true }],
    },
    values,
    blocks: [
        {
            instanceId: 'letterhead',
            blockRef: 'common.letterhead@v1',
            slot: 'letterhead',
            input: { title: TITLE, form_number: FORM_NUMBER },
        },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        {
            instanceId: 'heading',
            blockRef: 'common.document-heading@v1',
            input: { title: 'Strandningsmeddelande', subtitle: 'enligt 18 § hyresförhandlingslagen (1978:304)' },
        },
        { instanceId: 'mottagare', blockRef: 'strandning.mottagare@v1', input: {} },
        { instanceId: 'strandning', blockRef: 'strandning.strandning@v1', input: {} },
        {
            instanceId: 'underskrift',
            blockRef: 'forhandling.signing@v1',
            // 'För hyresvärden' is the signing heading; no extra 'Underskrifter' caption.
            input: { lead: 'För hyresvärden', lead_strong: true, heading: false, parties: signingPartiesFor(PARTY_SLOTS) },
        },
    ],
});
//# sourceMappingURL=strandningsmeddelande.js.map